import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "row justify-start q-mb-lg" };
const _hoisted_2 = { class: "text-h6" };
const _hoisted_3 = { class: "text-caption" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_img = _resolveComponent("q-img");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.links, (link) => {
            return (_openBlock(), _createElementBlock("div", {
                key: link.title,
                class: "col-12 col-sm-6 col-md-4 col-lg-3 q-pa-md"
            }, [
                _createVNode(_component_q_card, {
                    class: "cursor-pointer q-hoverable overflow-hidden",
                    onClick: ($event) => (_ctx.openLink(link.link))
                }, {
                    default: _withCtx(() => [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "q-focus-helper" }, null, -1)),
                        _createVNode(_component_q_img, {
                            src: link.image
                        }, null, 8, ["src"]),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(link.title), 1)
                            ]),
                            _: 2
                        }, 1024),
                        _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(link.exeplanation), 1)
                            ]),
                            _: 2
                        }, 1024)
                    ]),
                    _: 2
                }, 1032, ["onClick"])
            ]));
        }), 128))
    ]));
}
